import request from '../utils/request'

export default {
  // 获取消息列表
  getMessages() {
    return request.get('/api/message')
  },
  
  // 标记消息为已读
  markAsRead(id) {
    return request.put(`/api/message/${id}/read`)
  },
  
  // 获取未读消息数量
  getUnreadCount() {
    return request.get('/api/message/unread/count')
  }
}